import { modalAnatomy } from "@chakra-ui/anatomy";
import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps, createMultiStyleConfigHelpers } from "@chakra-ui/react";

const cardHelpers = createMultiStyleConfigHelpers(modalAnatomy.keys);
const Modal = cardHelpers.defineMultiStyleConfig({
  baseStyle: (props: StyleFunctionProps) => ({
    dialog: {
      bg: mode("white", "base.500")(props)
    }
  })
});

export default Modal;
